import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
// import animationData from '../lotties/4203-take-a-selfie.json'

class Applications extends Component {
  constructor(props) {
    super(props);
  }

  render() {


    return (
      <div className="applications" id="apps">
        

      </div>
    )
  }
}

export default Applications